import logo from '../../../../shared/img/logo/logo_MW.png';
import instaLogo from '../../../../shared/img/logo/insta_logo.png';

const addSlide1 = (pptx) => {
  // presentation slide
  const slide1 = pptx.addSlide();
  slide1.background = { color: '#c7effc' };
  slide1.addShape(pptx.ShapeType.ellipse, {
    x: 3.5,
    y: 0.1,
    w: 3.1,
    h: 3.1, // w = h -> cercle
    fill: { color: 'FFFFFF' },
    line: { color: 'FFFFFF' }, // pas de bordure visible
  });

  // add logo
  slide1.addImage({
    path: logo,
    x: 3.7,
    y: 0.7,
    w: 3,
    h: 1.7,
  });

  // add instagram logo
  slide1.addImage({
    path: instaLogo,
    x: 3.8,
    y: 5.03,
    w: 0.3,
    h: 0.3,
  });

  slide1.addText(
    [
      {
        text: 'English World',
        options: {
          fontSize: 22,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
      {
        text: '8 rue Georges de la Tour 54000 Nancy',
        options: {
          fontSize: 22,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
    ],
    {
      x: 1.25,
      y: 3.7,
      align: 'center',
    },
  );
  slide1.addText(
    [
      {
        text: 'www.medicalworld.fr',
        options: {
          fontSize: 18,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
      {
        text: 'medicalworld.fr',
        options: {
          fontSize: 18,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
    ],
    {
      x: 1.25,
      y: 5,
      align: 'center',
    },
  );
};

export default addSlide1;
